import type { Locale } from "../types";

const enLocale: Locale = {
	everyText: "Every",
	periodLabel: "Period",
	atEveryText: "At/Every",
	minuteLabel: "Minute(s)",
	atOptionLabel: "At",
	everyOptionLabel: "Every",
	betweenText: "Between",
	inText: "In",
	onText: "On",
	andText: "And",
	monthLabel: "Month(s)",
	dayOfWeekLabel: "Day of the week",
	onEveryText: "On/Every",
	multiDayOfMonthLabel: "Day of the Month",
	dayOfMonthLabel: "Days",
	hourLabel: "Hour(s)",
	weekDaysOptions: [
		"SUNDAY",
		"MONDAY",
		"TUESDAY",
		"WEDNESDAY",
		"THURSDAY",
		"FRIDAY",
		"SATURDAY",
	],
	periodOptions: ["hour", "day", "week", "month", "year"],
	shortMonthOptions: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	],
	onOptionLabel: "on",
	lastDayOfMonthLabel: "Last day of month",
	cronDescriptionText: "en",
};

export default enLocale;
